import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";
import { getAmountCell, getStatusCell, getUserRole } from "../../utils/utils";
import { Button, Tooltip } from "@deere/fuel-react";
import {
  Cancel,
  Check,
  DoNotDisturbOnOutlined,
  Download,
  Info,
  Refresh,
} from "@mui/icons-material";
import LineItemsPanel from "./lineItemsPanel";
import { useTranslation } from "../../common/translation-context";
import { Checkbox } from "@mui/material";
import Banner from "../../common/Banner";
import { APP_ACTIONS, ROLES } from "../../constants/constant";
import ModalMessageFunction from "../../common/modal-message-function";
import { useSelector } from "react-redux";

function CalculationGrid(props) {
  const [data, setData] = useState([]);
  const [expandedRowIds, setExpandedRowIds] = useState([]);
  const [selectedPage, setSelectedPage] = useState("bp_check");
  const userData = useSelector((state) => state.userState.userData);
  const { translate: t } = useTranslation();
  const [actionPerformed, setActionPerformed] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [row, setRow] = useState([]);

  useEffect(() => {
    setSelectedPage(props.selectedPage);
    if (props.data && props.data.length > 0 && !props.schedulerStatus) {   
      const sortedData = props.data.map((row) => {
        if (
          row.ibRequestCalculationDTOList &&
          row.ibRequestCalculationDTOList.length > 0
        ) {
          const sortedList = [...row.ibRequestCalculationDTOList];
          sortedList.sort((a, b) => {
            const amountA =
              a.debitCreditIndicator === "H"
                ? -a.amountInDocCurrency
                : a.amountInDocCurrency;
            const amountB =
              b.debitCreditIndicator === "H"
                ? -b.amountInDocCurrency
                : b.amountInDocCurrency;
            return amountB - amountA;
          });
          return { ...row, ibRequestCalculationDTOList: sortedList };
        }
        return row;
      });
      setData(sortedData);
    } else {
      setData([]);
    }
  }, [props.data, props.selectedPage]);

const interestByCurrency = data.reduce((acc, row) => {
  if (row.currencyKey && row.totalInterest) {
    acc[row.currencyKey] = (acc[row.currencyKey] || 0) + row.totalInterest;
  }
  return acc;
}, {});

const interestDisplay =
  Object.keys(interestByCurrency).length === 0
    ? <span style={{ fontWeight: "bold" }}>0.00</span>
    : Object.entries(interestByCurrency).map(([currency, total]) => (
        <span
          key={currency}
          style={{
            display: "inline-block",
            padding: "4px 8px",
            marginRight: "8px",
            backgroundColor: "#f0f0f0",
            borderRadius: "4px",
            fontWeight: "bold",
          }}
        >
          {currency}: {total.toFixed(2)}
        </span>
      ));


  useEffect(() => {
    if (actionPerformed && requestType === "cancelDebitNote") {
      props.handleCancelDebitNoteClick(row);
    }
    setActionPerformed(false);
    setRequestType("");
  }, [actionPerformed, requestType]);

  const handleExpandedRowIdChange = (newIds) => {
    const recordData = data.find(
      (row) => row.assignmentNo === expandedRowIds[0],
    );
    if (expandedRowIds.length > 0 && recordData) {
      updateTotalInterest(
        recordData["id"],
        recordData["calculatedInterest"],
        recordData["assignmentNo"],
        recordData["customerNo"],
      );
    }
    setExpandedRowIds(newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds);
  };

  const updateTotalInterest = (id, interest, assignmentNo, customerNo) => {
    const updatedData = data.map((row) => {
      if (row.customerNo === customerNo && row.assignmentNo === assignmentNo) {
        row.totalInterest = row.ibRequestCalculationDTOList
          .map((item) => {
            if (item.id === id) {
              return interest;
            }
            return item.calculatedInterest;
          })
          .reduce((a, b) => a + Number(b), 0);
      }
      return row;
    });
    setData(updatedData);
  };

  const save = (savedData) => {
    props.save(savedData, data);
  };

  const detailPanel = ({ row }) => {
    const idsOfIbRequestCalculationDTOList =
      row.ibRequestCalculationDTOList.map((lineItem) => lineItem.id);

    return (
      <div style={{ height: "100%" }}>
        <LineItemsPanel
          rows={row.ibRequestCalculationDTOList}
          view={selectedPage}
          save={save}
          updateTotalInterest={updateTotalInterest}
          reasonCodes={props.reasonCodes}
          lastExpandedRowId={
            props.lastExpandedRowId
              ? idsOfIbRequestCalculationDTOList.find(
                  (item) => item === props.lastExpandedRowId,
                )
                ? props.lastExpandedRowId
                : idsOfIbRequestCalculationDTOList[0]
              : idsOfIbRequestCalculationDTOList[0]
          }
        />
      </div>
    );
  };

  const onCheckboxClick = (params) => {
    params.row.bpChecked = !params.row.bpChecked;
    setData([...data], params.row);
    props.handleCheckboxClick(params.row);
  };

  const totalNoOfDays = [
    {
      field: "totalNoOfDays",
      type: "number",
      renderHeader: () => {
        return <strong>No of Days</strong>;
      },
      width: 150,
      editable: false,
      renderCell: (params) => {
        return <div>{params.row.totalNoOfDays}</div>;
      },
    },
  ];

  const processAction = (action, requestType) => {
    setActionPerformed(action);
    setRequestType(requestType);
  };

  const modalManager = ModalMessageFunction(processAction);

  const getModalAction = (requestType, requestStatus) => {
    modalManager.getModal(requestType, requestStatus);
  };

  const handleCancelDebitClick = (row) => {
    setRow(row);
    getModalAction(APP_ACTIONS.CANCELLEDDEBITNOTE, "cancelDebitNote");
  };

  const bpCheckAction = [
    {
      field: "bpChecked",
      renderHeader: () => {
        return <div></div>;
      },
      width: 60,
      editable: false,
      renderCell: (params) => {
        return (
          <div>
            <Checkbox
              checked={params.row.bpChecked}
              onChange={() => onCheckboxClick(params)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </div>
        );
      },
    },
  ];

  const debitNoteNumber = [
    {
      field: "debitNoteNumber",
      renderHeader: () => {
        return <strong>Debit Note Number</strong>;
      },
      width: 150,
      editable: false,
      renderCell: (params) => {
        return <div>{params.row.debitNoteNumber}</div>;
      },
    },
  ];

  const actions = [
    {
      field: "actions",
      type: "actions",
      renderHeader: () => {
        return <strong>Actions</strong>;
      },
      width: selectedPage === "include" ? 180 : 180,
      renderCell: (params) => {
        return (
          <div
            className="grid-actions"
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            {modalManager.modal}
            {selectedPage === "include" || selectedPage === "bp_check" ? (
              <Tooltip title="Exclude from interest calculation">
                <GridActionsCellItem
                  icon={<DoNotDisturbOnOutlined />}
                  label="exclude"
                  sx={{
                    color: "inherit",
                  }}
                  onClick={() => props.handleExcludeClick(params.row)}
                />
              </Tooltip>
            ) : null}
            {selectedPage === "exclude" || selectedPage === "bp_check" ? (
              <Tooltip title="Include for interest calculation">
                <GridActionsCellItem
                  icon={<Check />}
                  label="include"
                  sx={{
                    color: "inherit",
                  }}
                  onClick={() => props.handleIncludeClick(params.row)}
                />
              </Tooltip>
            ) : null}
            {selectedPage === "include" || selectedPage === "logs" ? (
              <Tooltip title="Download PDF">
                <GridActionsCellItem
                  icon={<Download />}
                  label="PDF"
                  sx={{
                    color: "inherit",
                  }}
                  onClick={() => props.handleDownloadPDF(params.row)}
                />
              </Tooltip>
            ) : null}
            {selectedPage === "logs" ? (
              <Tooltip title="Cancel Debit Note">
                <GridActionsCellItem
                  icon={<Cancel />}
                  label="Cancel"
                  sx={{
                    color: "inherit",
                  }}
                  onClick={() => handleCancelDebitClick(params.row)}
                />
              </Tooltip>
            ) : null}
            {params.row.ibRequestCalculationDTOList[0]
              .cancelledDebitNoteNumber !== null &&
            params.row.ibRequestCalculationDTOList[0].creditNoteNumber !==
              null ? (
              <Tooltip title="Debit Note was Cancelled">
                <GridActionsCellItem
                  icon={<Info />}
                  label="Info"
                  sx={{
                    color: "inherit",
                  }}
                />
              </Tooltip>
            ) : null}

            {selectedPage === "bp_check" || selectedPage === "include" ? (
              <Tooltip title="Refresh Data From SAP">
                <GridActionsCellItem
                  icon={<Refresh />}
                  label="Refresh"
                  sx={{
                    color: "inherit",
                  }}
                  onClick={() => props.handleRefreshData(params.row)}
                />
              </Tooltip>
            ) : null}
          </div>
        );
      },
    },
  ];

  const gridColumns = [
    {
      field: "status",
      renderHeader: () => {
        return <strong>Status</strong>;
      },
      width: 250,
      editable: false,
      renderCell: (params) => {
        return <div>{getStatusCell(params.row.status)}</div>;
      },
    },
    {
      field: "customerNo",
      renderHeader: () => {
        return <strong>Customer Number</strong>;
      },
      width: 200,
      editable: false,
      renderCell: (params) => {
        return <div>{params.row.customerNo}</div>;
      },
    },
    {
      field: "assignmentNo",
      renderHeader: () => {
        return <strong>Assignment Number</strong>;
      },
      width: 300,
      editable: false,
      renderCell: (params) => {
        return <div>{params.row.assignmentNo}</div>;
      },
    },
    {
      field: "totalInterest",
      type: "number",
      renderHeader: () => {
        return <strong>Interest</strong>;
      },
      width: 200,
      editable: false,
      renderCell: (params) => {
        return getAmountCell(
          params.row.totalInterest,
          params.row.currencyKey,
        );
      },
    },
    {
      field: "country",
      renderHeader: () => {
        return <strong>Country</strong>;
      },
      width: 100,
      editable: false,
      renderCell: (params) => {
        return <div>{params.row.country}</div>;
      },
    },
  ];

  const columns =
    getUserRole(userData) === "BP" && selectedPage === "bp_check"
      ? gridColumns.concat(actions)
      : selectedPage === "include" && getUserRole(userData) === "BP"
        ? bpCheckAction
            .concat(gridColumns)
            .concat(totalNoOfDays)
            .concat(actions)
        : getUserRole(userData) === "BP" && selectedPage === "exclude"
          ? bpCheckAction.concat(gridColumns).concat(actions)
          : selectedPage === "include" && getUserRole(userData) === "BP"
            ? gridColumns.concat(totalNoOfDays).concat(actions)
            : selectedPage === "include" && getUserRole(userData) !== "BP"
              ? gridColumns.concat(totalNoOfDays)
              : selectedPage === "logs"
                ? gridColumns
                    .slice(0, -1)
                    .concat(debitNoteNumber)
                    .concat(actions)
                : gridColumns;

  const bookInterest = (
    <Button
      variant="primary"
      //       disabled={true}
      disabled={props.isBookingActive}
      onClick={props.handleOnBookInterstClick}
    >
      {t("bookInterest")}
    </Button>
  );

  const downloadLogs = (
   <Button 
    variant="primary" 
    disabled={props.logsCount === 0 || !props.data || props.data.length === 0}
    onClick={props.handleDownloadLogsClick}
    style={{
      backgroundColor: (props.logsCount === 0 || !props.data || props.data.length === 0) ? "gray" : "#ffde00",
    }}
  >
    Download Logs
  </Button>
  );

  const downloadAllLogs = (
    <Button variant="primary" onClick={props.handleDownloadAllLogsClick}
     disabled={props.bpCheckCount === 0 || !props.data || props.data.length === 0}style={{
      backgroundColor: (props.bpCheckCount === 0 || !props.data || props.data.length === 0) ? "gray" : "#ffde00",
    }}>
      Download
    </Button>
  );

  const getCustomId = (row) => row.assignmentNo;

  const schedulerBanner = () => {
    if (props.schedulerStatus) {
      return (
        <div style={{ paddingInline: "10px" }}>
          <Banner bannerMsg={t("interestCalculationBanner")} />
        </div>
      );
    }
  };

  const gridToolbar = () => {
    return (
      <div>
        {schedulerBanner()}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px",
          }}
        >
          <h3>{`Positions(${data.length})`}</h3>
          {selectedPage === "include" &&
            getUserRole(userData) === ROLES.BP &&
            bookInterest}
           {selectedPage === "logs" && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
              marginRight: "5px"
            }}
          >
           
<div style={{ marginRight: "60px", fontWeight: "bold" }}>
  Total Interest: {interestDisplay}
</div>


            {downloadLogs}
          </div>
        )}
        {selectedPage === "bp_check" && downloadAllLogs}
      </div>
        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
        </GridToolbarContainer>
      </div>
    );
  };

  return (
    <div>
      <div>
        <DataGridPro
          loading={props.isLoaderVisible}
          rows={data}
          columns={columns}
          getRowId={getCustomId}
          getDetailPanelContent={detailPanel}
          getDetailPanelHeight={({ row }) => "auto"}
          detailPanelExpandedRowIds={expandedRowIds}
          onDetailPanelExpandedRowIdsChange={handleExpandedRowIdChange}
          disableRowSelectionOnClick
          pagination
          paginationMode="client"
          pageSizeOptions={[5, 10, 20, 25, 50, 100]}
          slots={{
            toolbar: gridToolbar,
          }}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              boxShadow: "0px 8px 8px rgba(0,0,0,0.1)",
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#fff",
            },
            "& .MuiDataGrid-cell": {
              backgroundColor: "#fff",
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
              
            },
            "& .MuiDataGrid-filler": {
              backgroundColor: "#fff",
            },
            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            backgroundColor: "#fff",
            marginBottom: "10px",
            height: "900px",
            width: "100%",
          }}
        />
      </div>
    </div>
  );
}

export default CalculationGrid;
